<template>
  <BaseDialog
    title="後台手動標記"
    :visible="true"
    :close-on-click-modal="false"
    @close="$emit('close')"
    @confirm="updateStatus"
  >
    <BaseElForm
      ref="formRef"
      :model="formData"
      :rules="formRules"
      label-position="top"
    >
      <BaseElFormItem label="操作" prop="status">
        <BaseElSelect
          v-model="formData.status"
          placeholder="請選擇標記狀態"
        >
          <BaseElSelectOption
            v-for="item in markedStatusOptions"
            :key="item.value"
            :label="item.optionLabel"
            :value="item.value"
          />
        </BaseElSelect>
      </BaseElFormItem>
    </BaseElForm>
    <GrayBlockContainer class="mt-4 flex items-start gap-2">
      <MaterialIcon :size="24" class="text-primary-100 mt-0.5 flex-shrink-0">info_outline</MaterialIcon>
      <div class="text-sub leading-relaxed text-gray-80">
        <p class="m-0">標記狀態<span class="text-primary-100">不會影響系統獎勵的觸發與回收</span>。</p>
        <p class="m-0">如需<span class="text-primary-100">更動訂單實際狀態與獎勵回收</span>，請返回上一頁使用「<span class="text-primary-100">作廢/退貨</span>」功能。</p>
      </div>
    </GrayBlockContainer>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/Dialog/BaseDialog.vue'
import GrayBlockContainer from '@/components/Container/GrayBlockContainer.vue'
import MaterialIcon from '@/components/MaterialIcon.vue'
import { noEmptyRules } from '@/validation/index'
import { markedStatusConfig } from '@/config/externalTransaction'
import { onMounted, computed } from 'vue'
import { useBaseForm } from '@/use/useForm'
import { omit } from 'lodash'

export default {
  name: 'MarkExternalTransactionModal',
  components: {
    BaseDialog,
    GrayBlockContainer,
    MaterialIcon,
  },
  props: {
    status: {
      type: String,
    },
  },
  setup (props, { emit }) {
    const { formRef, formData, initFormData, checkForm } = useBaseForm()
    const markedStatusOptions = computed(() => {
      const omitList = ['systemInvalid']
      return omit(markedStatusConfig, omitList)
    })
    const formRules = {
      status: [noEmptyRules()],
    }
    initFormData({
      status: '',
    })
    const updateStatus = async () => {
      const pass = await checkForm(formRef.value)
      if (!pass) return
      emit('updateStatus', formData.status)
    }
    onMounted(() => {
      formData.status = props.status
    })
    return {
      markedStatusOptions,
      formRef,
      formData,
      formRules,
      updateStatus,
    }
  },
}
</script>

<style></style>
